import { useState } from 'react';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9qrqdee3oq4jqumtpqg';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpVal = (formData.get('phone_alt') as string || '').trim();

    if (hpVal) {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email.trim()) {
      setStatus('error');
      setErrorMsg('请输入您的邮箱地址');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const payload = new FormData();
      payload.append('email', email.trim());

      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: email.trim() } as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = (parsed && ((parsed as Record<string, unknown>).meta as Record<string, unknown>)?.message as string)
          || (parsed && (parsed as Record<string, unknown>).message as string)
          || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setErrorMsg('提交失败，请稍后重试');
        } else {
          setStatus('error');
          setErrorMsg(serverMsg || '订阅失败，请稍后重试');
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试');
    } finally {
      if (status === 'loading') {
        // keep loading state until resolved
      }
    }
  };

  return (
    <section className="py-16 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dark%20elegant%20background%20with%20subtle%20newspaper%20texture%2C%20warm%20red%20and%20gold%20accents%2C%20mysterious%20atmosphere%2C%20journalism%20theme%2C%20vintage%20press%20room%20aesthetic%20with%20modern%20touch&width=1600&height=600&seq=newsletter-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-background-950/85"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-primary-500/20 flex items-center justify-center">
          <i className="ri-mail-send-line text-2xl text-primary-400"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          吃瓜简报 · 每日推送
        </h2>
        <p className="text-white/60 mb-8 text-sm md:text-base">
          订阅黑料不打烊每日简报，最新娱乐圈猛料第一时间送到你的邮箱。关注黑料不打烊，吃瓜永不缺货！
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 text-accent-400 py-4">
            <i className="ri-check-double-line text-xl"></i>
            <span className="font-medium">订阅成功！记得查收确认邮件哦~</span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              className="form-hp"
              tabIndex={-1}
              autoComplete="off"
              readOnly
              aria-hidden="true"
            />
            <div className="relative flex-1 w-full">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="ri-mail-line text-foreground-400"></i>
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                className="w-full pl-11 pr-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/40 text-sm focus:outline-none focus:border-primary-400 transition-colors"
                required
              />
            </div>
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-bold rounded-lg hover:bg-primary-600 disabled:opacity-60 transition-all duration-200 whitespace-nowrap"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>订阅中
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  <i className="ri-send-plane-line"></i>免费订阅
                </span>
              )}
            </button>
          </form>
        )}

        {status === 'error' && errorMsg && (
          <p className="mt-3 text-sm text-red-400">{errorMsg}</p>
        )}

        <p className="mt-4 text-xs text-white/30">
          已有 <strong className="text-white/50">128,630</strong> 位吃瓜群众订阅 · 绝不发送垃圾邮件
        </p>
      </div>
    </section>
  );
}